__webpack_require__.p = "/global-afk-2407/";